import React, { Component } from "react";
import { withStyles } from "@material-ui/styles";
import _ from "lodash";
import PropTypes from "prop-types";
import Img from "react-image";
import srcAddWhite from "../../../../styles/img/add-white.svg";
import moment from "moment";
import srcBiberon from "../../../../styles/img/etat-biberon-grey.svg";
import srcRepas from "../../../../styles/img/etat-repas-grey.svg";
import srcSieste from "../../../../styles/img/etat-sieste-grey.svg";
import srcSante from "../../../../styles/img/etat-sante-grey.svg";
import srcAlert from "../../../../styles/img/etat-alert-grey.svg";
import srcMedicament from "../../../../styles/img/etat-medicament-grey.svg";
import srcBanderole from "../../../../styles/img/banderole-anniv.png";
import srcBiberonOrange from "../../../../styles/img/etat-biberon-orange.svg";
import srcBiberonBlue from "../../../../styles/img/etat-biberon-blue.svg";
import srcRepasBlue from "../../../../styles/img/etat-repas-blue.svg";
import srcSiesteBlue from "../../../../styles/img/etat-sieste-blue.svg";
import srcSanteRed from "../../../../styles/img/etat-sante-red.svg";
import srcAlertRed from "../../../../styles/img/etat-alert-red.svg";
import srcMedicamentBlue from "../../../../styles/img/etat-medicament-blue.svg";
import srcRetardParent from "../../../../styles/img/icon-parent-late.svg";
import { getStatusToString, SVGIcon } from "../../../../ReactConst2";
import KidItemStyle from "./KidItemStyle";
import { withTranslation } from 'react-i18next';
import { Redirect } from "react-router-dom";
import { AddButton } from "../../../../components";

const AddWhite = (props) => (
  <object
    onClick={props.onClick}
    data={srcAddWhite}
    type="image/svg+xml"
    style={{ width: "16px", height: "16px", cursor: "pointer" }}
    className="img-fluid"
  />
);
const AddWhite2 = (props) => (
  <svg
    onClick={props.onClick}
    style={{ cursor: "pointer", pointerEvents: "none" }}
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="491.9px"
    height="491.9px"
    fill="#FFFFFF"
    viewBox="0 0 491.9 491.9"
    space="preserve"
  >
    <path
      className="st0"
      d="M465.2,211.6H280.2V26.7c0-8.4-11.4-26.7-34.3-26.7s-34.3,18.3-34.3,26.7v184.9H26.7
			c-8.4,0-26.7,11.4-26.7,34.3s18.3,34.3,26.7,34.3h184.9v184.9c0,8.4,11.4,26.7,34.3,26.7s34.3-18.3,34.3-26.7V280.2h184.9
			c8.4,0,26.7-11.4,26.7-34.3S473.6,211.6,465.2,211.6z"
    />
  </svg>
);

const GreyBiberon = (props) => <Img src={srcBiberon} className="img-fluid" />;
const GreyRepas = (props) => <Img src={srcRepas} className="img-fluid" />;
const GreySieste = (props) => <Img src={srcSieste} className="img-fluid" />;

const GreySante = (props) => <Img src={srcSante} className="img-fluid" />;
const GreyAlert = (props) => <Img src={srcAlert} className="img-fluid" />;
const GreyMedicament = (props) => (
  <Img src={srcMedicament} className="img-fluid" />
);

const OrangeBiberon = (props) => (
  <Img src={srcBiberonOrange} className="img-fluid" />
);
const BlueBiberon = (props) => (
  <Img src={srcBiberonBlue} className="img-fluid" />
);
const BlueRepas = (props) => <Img src={srcRepasBlue} className="img-fluid" />;
const BlueSieste = (props) => <Img src={srcSiesteBlue} className="img-fluid" />;

const RedSante = (props) => <Img src={srcSanteRed} className="img-fluid" />;
const RedAlert = (props) => <Img src={srcAlertRed} className="img-fluid" />;
const BlueMedicament = (props) => (
  <Img src={srcMedicamentBlue} className="img-fluid" />
);

const RetardParent = (props) => (
  <Img src={srcRetardParent} className="img-fluid" />
);

function jsUpperCaseFirst(string) {
  return _.isEmpty(string) ? string : string.charAt(0).toUpperCase();
}
function yesRetard(kid) {
  return kid ? "retard" : "";
}
function formatRetard(retardTime) {
  let result = "";

  let minutes = moment(retardTime, "HH:mm").minutes();
  let hours = moment(retardTime, "HH:mm").hours();
  if (hours > 0 && minutes > 0) {
    result = moment(retardTime, "HH:mm").format("H[h]mm[mn]");
  }
  if (hours === 0 && minutes > 0) {
    result = moment(retardTime, "HH:mm").format("mm[mn]");
  } else if (minutes === 0 && hours > 0) {
    result = moment(retardTime, "HH:mm").format("H[h]");
  }
  return result;
}
class KidItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lienPhoto: "",
      redirect: null,
      modalNotifications: false,
    };
    this.openFicheEnfant = this.openFicheEnfant.bind(this);
  }
  openFicheEnfant(kid) {
     this.setState({ redirect: `/enfant/${kid.id}/journee` });
  }

  render() {
    const { kid, classes, editEnfant, handleLoad } = this.props;
    var divStyle = (lienPhoto) => ({
      backgroundImage: "url(" + lienPhoto + ")",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
    });
    let prenom = "";
    let nameUpperCase = "";
    let statut = "";
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    } else if (!_.isEmpty(kid)) {
      prenom = kid.prenom;
      nameUpperCase = jsUpperCaseFirst(kid.nom);
      statut = !_.isEmpty(kid.agenda)
        ? (statut = kid.agenda.statutDetails.statut)
        : (statut = "ABSENT");
      return (
        <div className={classes.cardchild}>
          <div
            className={`card card-child ${statut.toLowerCase()} ${yesRetard(
              kid.retardTime
            )}`}
          >
            {moment(kid.dateNaissance).isSame(moment().format("YYYY-MM-DD")) ? (
              <Img src={srcBanderole} className="banderole-anniv" alt="" />
            ) : (
              ""
            )}
            {kid.nbNotifications && kid.nbNotifications !== 0 ? (
              <a
                href="#"
                className="pastille-notif"
                onClick={(event) => {
                  event.preventDefault();
                  this.openFicheEnfant(kid);
                }}
              >
                {kid.nbNotifications}
              </a>
            ) : (
              ""
            )}
            <a
              style={{ cursor: "pointer" }}
              onClick={(event) => {
                event.preventDefault();
                editEnfant(kid);
              }}
              data-toggle="modal"
              data-target="#modalChildUnit"
              className="round-add-btn d-flex align-items-center justify-content-center gradient"
            >
              <AddButton
                onClick={(event) => {
                  event.preventDefault();
                  editEnfant(kid);
                }}
                style={{ cursor: "pointer" }}
              />
            </a>
            <span
              className="avatar-child"
              style={divStyle(this.props.kid.lienPhoto)}
              onClick={(event) => {
                event.preventDefault();
                this.openFicheEnfant(kid);
              }}
            ></span>
            <div
              className="card-body"
              onClick={(event) => {
                event.preventDefault();
                this.openFicheEnfant(kid);
              }}
            >
              <div className="d-flex justify-content-center align-items-center">
                {!_.isEmpty(kid.retardTime) ? (
                  <RetardParent class="img-fluid" alt="" />
                ) : (
                  <SVGIcon name={statut} size="26px" />
                )}
                <div className="child-infos">
                  <h3>{prenom + " " + nameUpperCase + "."}</h3>
                  {kid.sectionNom && (
                    <span
                      style={{
                        display: "inline-block",
                        fontSize: "0.65em",
                        padding: "1px 8px",
                        borderRadius: "10px",
                        backgroundColor: kid.sectionCouleur || "#ccc",
                        color: "#fff",
                        marginBottom: "2px",
                        lineHeight: "1.4",
                      }}
                    >
                      {kid.sectionNom}
                    </span>
                  )}
                  {!_.isEmpty(kid.retardTime) ? (
                    <p>{this.props.t('status.late_by') + " " + formatRetard(kid.retardTime)}</p>
                  ) : (
                    <p>
                      {getStatusToString(
                        statut,
                        kid.agenda.statutDetails.dateTime,
                        this.props.t
                      )}
                    </p>
                  )}
                </div>
              </div>
              <div className="etat-infos d-flex align-items-center justify-content-center">
                <div className="icone-etat large-icon">
                  {!_.isEmpty(kid.biberon) &&
                  kid.biberon.nbBiberons &&
                  kid.biberon.nbBiberons > 0 ? (
                    <span className="pastille">{kid.biberon.nbBiberons}</span>
                  ) : (
                    ""
                  )}
                  {_.isEmpty(kid.biberon) || statut === "ATTENDU" ? (
                    <GreyBiberon />
                  ) : !_.isEmpty(kid.biberon) && kid.biberon.actif === false ? (
                    <GreyBiberon />
                  ) : kid.biberon.actif === true &&
                    kid.biberon.enRetard === true ? (
                    <OrangeBiberon />
                  ) : kid.biberon.actif === true &&
                    kid.biberon.enRetard === false &&
                    kid.biberon.nbBiberons &&
                    kid.biberon.nbBiberons >= 1 ? (
                    <BlueBiberon />
                  ) : (
                    <GreyBiberon />
                  )}
                </div>
                <div className="icone-etat large-icon">
                  {statut === "ATTENDU" ? (
                    <GreyRepas />
                  ) : kid.repasPris ? (
                    <BlueRepas />
                  ) : (
                    <GreyRepas />
                  )}
                </div>
                <div className="icone-etat">
                  {statut === "ATTENDU" ? (
                    <GreySieste />
                  ) : kid.siestePrise ? (
                    <BlueSieste />
                  ) : (
                    <GreySieste />
                  )}
                </div>
                <div className="icone-etat">
                  {statut === "ATTENDU" || statut === "ABSENT" ? (
                    <GreySante />
                  ) : !_.isEmpty(kid.etatSante) &&
                    !_.isEmpty(kid.etatSante.etatSante) &&
                    kid.etatSante.etatSante == "RIEN_DE_GRAVE" ? (
                    <GreySante />
                  ) : (
                    <RedSante />
                  )}
                </div>
                <div className="icone-etat">
                  {statut === "ATTENDU" ? (
                    <GreyAlert />
                  ) : kid.incident ? (
                    <RedAlert />
                  ) : (
                    <GreyAlert />
                  )}
                </div>
                <div className="icone-etat large-icon">
                  {statut === "ATTENDU" ? (
                    <GreyMedicament />
                  ) : !_.isEmpty(kid.etatSante) &&
                    kid.etatSante.sousTraitement === true ? (
                    <BlueMedicament />
                  ) : (
                    <GreyMedicament />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
}
KidItem.propTypes = {
  kid: PropTypes.object,
  classes: PropTypes.object,
};

export default withStyles(KidItemStyle)(withTranslation()(KidItem));
